<template>
  <v-app>
    <div transition="fade-transition">
      <v-card tile transition="fade-transition">
        <v-container fluid>
          <v-form ref="feedbackform" id="content-story-form" v-model="valid" lazy-validation>
            <v-layout wrap justify-center mb-2>
              <v-flex class="content xs12 pt-2 md12">
                <div class="storyboard-page-toolbar">
                  <h2 v-if="isCreateMode" class="form-title mb-0">Content Storyboard Flow</h2>
                  <v-btn
                    v-if="isInternalView"
                    class="version-history-toggle"
                    color="secondary"
                    text
                    :aria-expanded="showVersionHistory ? 'true' : 'false'"
                    @click="showVersionHistory = !showVersionHistory"
                  >
                    <v-icon left>mdi-history</v-icon>
                    {{ showVersionHistory ? 'Hide history' : 'Version history' }}
                    <v-icon right>{{ showVersionHistory ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
                  </v-btn>
                </div>
                <div class="storyboard-workspace">
                  <v-slide-x-transition>
                    <aside v-if="isInternalView && showVersionHistory" class="version-history-column">
                      <v-card class="version-history-card">
                        <v-card-title class="version-history-title">
                          Version History
                        </v-card-title>
                        <v-card-text class="version-history-list">
                          <v-list dense>
                          <template v-for="(hpost, i) in contentScriptVersions">
                            <v-list-item
                              :key="hpost.id + i"
                              :class="{'version-history-item--selected': hpost.id === creatorConceptData.id}"
                              @click="switchVersion(hpost)"
                            >
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ hpost.versionNo }} {{ hpost.isMain ? `(Active)` : ''}}
                                </v-list-item-title>
                                <v-list-item-title>
                                  {{ hpost.isMain ? `${formatDate(hpost.createdAt)}` : formatDate(hpost.createdAt)}}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action v-if="hpost.id === creatorConceptData.id">
                                <v-icon color="green">check_circle</v-icon>
                              </v-list-item-action>
                              <v-list-item-action v-if="hpost.id !== creatorConceptData.id && hpost.id === mainData.id">
                                <v-icon color="green">check_circle_outline</v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </template>
                          </v-list>
                        </v-card-text>
                        <v-card-actions class="version-history-actions">
                          <v-btn block color="primary" @click="setMainVersion(creatorConceptData.id)">
                              Change to this version
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </aside>
                  </v-slide-x-transition>
                  <div class="storyboard-editor-column">
                    <v-row v-if="creatorConceptData.approved">
                      <v-col cols="12">
                        <v-alert type="success" dense>
                          Approved
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col class="pt-0" cols="12">
                        <v-col class="px-5 pt-0 clearfix" cols="12">
                          <v-col class="col-xs-12 col-md-12 pb-0">
                            <div class="storyboard-header">
                              <div class="storyboard-meta">
                                <div class="mb-2">
                                  <span class="h4 font-weight-bold mb-2">Campaign Name</span>:&nbsp;
                                  <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ creatorConceptData.campaignName }}</span>
                                </div>
                                <div class="mb-2">
                                  <span class="h4 font-weight-bold mb-2">Creator Handle</span>:&nbsp;
                                  <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ creatorConceptData.creatorHandle }}</span>
                                </div>
                              </div>
                              <div class="avatar-logo" v-if="isCreateMode">
                                <a href="https://www.getkobe.com" target="_blank">
                                  <img :src="logoDataUrl" alt="KOBE Logo"/>
                                </a>
                              </div>
                            </div>
                            <div class="mb-2">
                              <span class="h4 font-weight-bold mb-2">Draft Submission Date</span>:&nbsp;
                              <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ creatorConceptData.submissionDate }}</span>
                            </div>
                            <div class="mb-2">
                              <span class="h4 font-weight-bold mb-2">Deliverable Details</span>:&nbsp;
                              <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ creatorConceptData.deliverableLists }}</span>
                            </div>
                          </v-col>
                          <!-- Start IG Reel -->
                          <div v-for="(deliItem, deliIndex) in creatorConceptData.deliverables" :key="deliIndex">
                            <v-col class="col-xs-12 col-md-12 pt-1 pb-1" style="background: rgb(244, 244, 244);">
                              <div class="d-flex flex-row" style="justify-content:space-between">
                                <span class="h4 font-weight-bold mb-2 pt-0 pb-0">{{ deliItem.title }}</span>
                                <div>
                                  <v-menu                                                            
                                    v-show="deliItem.showChat"
                                    :close-on-content-click="false"
                                    bottom
                                    offset-x
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-badge
                                        @click.stop="showChatBox(deliIndex)"
                                        :value="deliItem.comments ? deliItem.comments.length : ''"
                                        :content="deliItem.comments ? deliItem.comments.length : ''"
                                        color="black"
                                        overlap
                                        style="margin-left:-10px;"
                                        v-if="isCommentSection"
                                      >
                                        <v-btn 
                                          v-bind="attrs"
                                          v-on="on"
                                          text
                                          style="padding:0;min-width:34px;"
                                          @click="showChatBox(deliIndex)"
                                          v-if="isCommentSection">
                                          <v-icon color="secondary">chat</v-icon>
                                        </v-btn>
                                      </v-badge>
                                    </template>
                                    <v-card max-width="300" style="text-align: left;">
                                      <v-card-text style="background-color:#fff;padding:0">
                                        <chatbox
                                          :messages="deliItem.comments"
                                          title=""
                                          @sendMessage="sendComment(deliItem.id, $event)"
                                        />
                                      </v-card-text>
                                    </v-card>
                                  </v-menu>
                                  <div class="putComment" v-show="deliItem.showComment">
                                    <span>Put your comments here</span>
                                    <span style="cursor:pointer"  @click="closePutComment(deliIndex)"><v-icon small color="white">mdi-close-circle</v-icon></span>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                            <div v-if="deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn'">
                              <v-col class="col-xs-12 col-md-12">
                                <div class="d-flex row col mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Concept:</span>
                                  <v-textarea
                                    v-model="deliItem.concept"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                                <div class="d-flex row col mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Reason for concept:</span>
                                  <v-textarea
                                    v-model="deliItem.reasonConcept"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                                <div class="d-flex row col mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Music choice:</span>
                                  <v-textarea
                                    v-model="deliItem.musicChoice"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                              </v-col>
                              <v-col class="col-xs-12 col-md-12 d-flex flex-row" v-for="(boxItem, boxIdx) in deliItem.boxes" :key="boxIdx">
                                <v-flex class="xs12">
                                  <table class="content-script-table" style="border:none" dense>
                                      <thead>
                                        <tr>
                                          <th width="40%" class="text-left">
                                            Descriptions of scenes/ footage
                                          </th>
                                          <th width="40%" class="text-left">
                                            Include text overlays / voiceover script in each scene
                                          </th>
                                          <th width="40%" class="text-left">
                                            Reference links/images
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <div class="d-flex flex-row align-center justify-space-between mb-1">
                                              <span class="tbl-inner-title">INTRO: (can be hook/ theme/ title of your video)</span>
                                            
                                            
                                              <!-- <v-textarea
                                                class="sm-text-area"
                                                height="150px"
                                                placeholder="What will make your audience want to watch this content? 
            Scene 1:
            "
                                                v-model="boxItem.scenesInfo"
                                                v-if="isNotClient"
                                                outlined
                                                required
                                                dense
                                                hide-details
                                              ></v-textarea> -->
                                             <div class="editor-header-actions">
                                                <editor-format-info
                                                  v-if="isNotClient"
                                                  :format="storyboardPlaceholders.scenesInfo"
                                                />
                                                <v-menu
                                                  v-show="boxItem.showChat"
                                                  :close-on-content-click="false"
                                                  bottom
                                                  offset-x
                                                >
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-badge
                                                      @click.stop="showChatBox(deliIndex, boxIdx)"
                                                      :value="boxItem.introComments ? boxItem.introComments.length : ''"
                                                      :content="boxItem.introComments ? boxItem.introComments.length : ''"
                                                      color="black"
                                                      overlap
                                                      style="margin-left:-10px;"
                                                      v-if="isCommentSection"
                                                    >
                                                      <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        text
                                                        style="padding:0;min-width:34px;"
                                                        @click="showChatBox(deliIndex, boxIdx)"
                                                        v-if="isCommentSection"
                                                      >
                                                        <v-icon color="secondary">chat</v-icon>
                                                      </v-btn>
                                                    </v-badge>
                                                  </template>
                                                  <v-card max-width="300" style="text-align: left;">
                                                    <v-card-text style="background-color:#fff;padding:0">
                                                      <!-- {{boxItem.introComments}} -->
                                                      <chatbox
                                                        :messages="boxItem.introComments"
                                                        title=""
                                                        @sendMessage="sendComment(boxItem.id, $event, 'introComments')"
                                                      />
                                                    </v-card-text>
                                                  </v-card>
                                                </v-menu>
                                                <!-- <div class="putComment" v-show="boxItem.showComment">
                                                  <span>Put your comments here</span>
                                                  <span style="cursor:pointer" @click="closePutComment(deliIndex, boxIdx)"><v-icon small color="white">mdi-close-circle</v-icon></span>
                                                </div> -->
                                              </div>
                                            </div>
                                            <sun-editor
                                              v-if="isNotClient"
                                              v-model="boxItem.scenesInfo"
                                              :button-list="storyboardToolbar"
                                              :placeholder="storyboardPlaceholders.scenesInfo"
                                              width="100%"
                                              height="150"
                                            />
                                            <p
                                              class="cp"
                                              style="min-height:150px;max-height: 150px;overflow-y: auto;"
                                              v-if="isClient"
                                              v-html="renderHTML(boxItem.scenesInfo)"
                                            >
                                            </p>
                                          </td>
                                          <td>
                                            <div class="text-right mb-1" style="min-height: 18px;">
                                              <!-- <span class="tbl-inner-title">INTRO: (can be hook/ theme/ title of your video)</span> -->
                                            
                                            
                                              <!-- <v-textarea
                                                class="sm-text-area"
                                                height="150px"
                                                placeholder="What will make your audience want to watch this content? 
            Scene 1:
            "
                                                v-model="boxItem.scenesInfo"
                                                v-if="isNotClient"
                                                outlined
                                                required
                                                dense
                                                hide-details
                                              ></v-textarea> -->
                                               <div class="editor-header-actions">
                                                <editor-format-info
                                                  v-if="isNotClient"
                                                  :format="storyboardPlaceholders.briefText"
                                                />
                                                <v-menu
                                                  v-show="boxItem.showChatTwo"
                                                  :close-on-content-click="false"
                                                  bottom
                                                  offset-x
                                                >
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-badge
                                                      @click.stop="showChatBoxTwo(deliIndex, boxIdx)"
                                                      :value="boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : ''"
                                                      :content="boxItem.introCommentsTwo ? boxItem.introCommentsTwo.length : ''"
                                                      color="black"
                                                      overlap
                                                      style="margin-left:-10px;"
                                                      v-if="isCommentSection"
                                                    >
                                                      <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        text
                                                        style="padding:0;min-width:34px;"
                                                        @click="showChatBoxTwo(deliIndex, boxIdx)"
                                                        v-if="isCommentSection"
                                                      >
                                                        <v-icon color="secondary">chat</v-icon>
                                                      </v-btn>
                                                    </v-badge>
                                                  </template>
                                                  <v-card max-width="300" style="text-align: left;">
                                                    <v-card-text style="background-color:#fff;padding:0">
                                                      <!-- {{boxItem.introCommentsTwo}} -->
                                                      <chatbox
                                                        :messages="boxItem.introCommentsTwo"
                                                        title=""
                                                        @sendMessage="sendCommentTwo(boxItem.id, $event, 'introCommentsTwo')"
                                                      />
                                                    </v-card-text>
                                                  </v-card>
                                                </v-menu>
                                                <!-- <div class="putComment" v-show="boxItem.showComment">
                                                  <span>Put your comments here</span>
                                                  <span style="cursor:pointer" @click="closePutComment(deliIndex, boxIdx)"><v-icon small color="white">mdi-close-circle</v-icon></span>
                                                </div> -->
                                              </div>
                                            </div>
                                            <sun-editor
                                              v-if="isNotClient"
                                              v-model="boxItem.briefText"
                                              :button-list="storyboardToolbar"
                                              :placeholder="storyboardPlaceholders.briefText"
                                              width="100%"
                                              height="150"
                                            />
                                            <!-- <v-textarea
                                              class="sm-text-area"
                                              style="padding-top:20px"
                                              height="150px"
                                              placeholder="Text: 
          VO: 

          Relate 2-3 pointers of brief into your concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)
          "
                                              v-model="boxItem.briefText"
                                              v-if="isNotClient"
                                              outlined
                                              required
                                              dense
                                              hide-details
                                            ></v-textarea> -->
                                            <div
                                              class="cp"
                                              style="min-height: 150px;max-height: 150px;overflow-y: auto;margin-top: 5px;"
                                              v-if="isClient"
                                              v-html="renderHTML(boxItem.briefText)"
                                            >
                                            </div>
                                          </td>
                                          <td rowspan="3" class="reference-cell">
                                            <div class="reference-upload-list">
                                              <div class="reference-upload-card" v-for="(item, imgIdx) in boxItem.images" :key="imgIdx">
                                                <div class="reference-upload-header">
                                                  <span class="reference-upload-title">Reference {{ imgIdx + 1 }}</span>
                                                  <v-btn
                                                    v-if="isNotClient"
                                                    class="reference-remove-btn"
                                                    @click="deleteImage(deliIndex, boxIdx, imgIdx)"
                                                    icon
                                                    x-small>
                                                    <v-icon color="red" small>mdi-close-circle</v-icon>
                                                  </v-btn>
                                                </div>
                                                <v-btn-toggle
                                                  v-model="item.refLinkType"
                                                  class="reference-type-toggle"
                                                  v-if="isNotClient"
                                                  mandatory
                                                  dense>
                                                  <v-btn value="upload" small>
                                                    <v-icon left small>mdi-image-outline</v-icon>
                                                    Image
                                                  </v-btn>
                                                  <v-btn value="link" small>
                                                    <v-icon left small>mdi-link-variant</v-icon>
                                                    Link
                                                  </v-btn>
                                                </v-btn-toggle>
                                                <div class="reference-upload-dropzone" :class="{'has-file': item.imgName}" v-if="item.refLinkType === 'upload'">
                                                  <v-icon class="reference-upload-icon" color="secondary">
                                                    {{ item.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline' }}
                                                  </v-icon>
                                                  <div class="reference-upload-copy">
                                                    <a :href="item.imgUrl" target="_blank" v-if="item.imgName">{{ getReferenceFileName(item) }}</a>
                                                    <span v-if="!item.imgName">Upload image</span>
                                                    <small v-if="isNotClient">Select multiple files to add references at once</small>
                                                  </div>
                                                  <direct-file-upload
                                                    class="reference-upload-action"
                                                    :icon-only="true"
                                                    :multiple="true"
                                                    @setMedias="uploadFile(deliIndex, boxIdx, imgIdx, ...arguments)"
                                                    v-if="isNotClient"
                                                  />
                                                </div>
                                                <v-text-field
                                                  v-if="item.refLinkType === 'link'"
                                                  dense
                                                  class="purple-input reference-link-field"
                                                  v-model="item.link"
                                                  :disabled="isClient"
                                                  type="textbox"
                                                  outlined
                                                  required
                                                  hide-details
                                                  placeholder="Paste reference link"
                                                />
                                              </div>
                                              <v-btn class="reference-add-btn" @click="addImage(deliIndex, boxIdx)" v-if="isNotClient" small text>
                                                <v-icon left small>mdi-plus</v-icon>
                                                Add reference
                                              </v-btn>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div class="d-flex flex-row align-center justify-space-between mb-1">
                                              <span class="tbl-inner-title">BODY</span>
                                              <div class="editor-header-actions">
                                                <editor-format-info
                                                  v-if="isNotClient"
                                                  :format="storyboardPlaceholders.bodyInfo"
                                                />
                                                <v-menu
                                                  v-show="boxItem.showChatBody"
                                                  :close-on-content-click="false"
                                                  bottom
                                                  offset-x
                                                >
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-badge
                                                      @click.stop="showBodyChatBox(deliIndex, boxIdx)"
                                                      :value="boxItem.bodyComments ? boxItem.bodyComments.length : ''"
                                                      :content="boxItem.bodyComments ? boxItem.bodyComments.length : ''"
                                                      color="black"
                                                      overlap
                                                      style="margin-left:-10px;"
                                                      v-if="isCommentSection"
                                                    >
                                                      <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        text
                                                        style="padding:0;min-width:34px;"
                                                        @click="showBodyChatBox(deliIndex, boxIdx)"
                                                        v-if="isCommentSection"
                                                      >
                                                        <v-icon color="secondary">chat</v-icon>
                                                      </v-btn>
                                                    </v-badge>
                                                  </template>
                                                  <v-card max-width="300" style="text-align: left;">
                                                    <v-card-text style="background-color:#fff;padding:0">
                                                      <chatbox
                                                        :messages="boxItem.bodyComments"
                                                        title=""
                                                        @sendMessage="sendBodyComment(boxItem.id, $event, 'bodyComments')"
                                                      />
                                                    </v-card-text>
                                                  </v-card>
                                                </v-menu>
                                              </div>
                                            </div>
                                            <sun-editor
                                              v-if="isNotClient"
                                              class="body-info-txt"
                                              v-model="boxItem.bodyInfo"
                                              :button-list="storyboardToolbar"
                                              :placeholder="storyboardPlaceholders.bodyInfo"
                                              width="100%"
                                              height="420"
                                            />
                                            <!-- <v-textarea
                                              class="sm-text-area"
                                              placeholder="Showcase how you plan to execute every scene and how you’ll feature the product/service that relates to the campaign brief.
                                              *Not every scene needs to have the product/ USPs

                                              Scene 2:

                                              Scene 3:
                                              "
                                              v-model="boxItem.bodyInfo"
                                              v-if="isNotClient"
                                              outlined
                                              required
                                              dense
                                              hide-details
                                              rows="15"
                                              style="min-height:420px"
                                            ></v-textarea> -->
                                            <p
                                              class="cp"
                                              style="min-height:420px;max-height: 420px;overflow-y: auto;"
                                              v-if="isClient"
                                              v-html="renderHTML(boxItem.bodyInfo)"
                                            >
                                            </p>
                                          </td>
                                          <td>
                                            <!-- <v-textarea
                                              class="sm-text-area"
                                              style="padding-top:21px;min-height:420px"
                                              placeholder="Text: VO: Relate 2-3 pointers of brief into your concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)"
                                              v-model="boxItem.briefPointer"
                                              v-if="isNotClient"
                                              outlined
                                              required
                                              dense
                                              hide-details
                                              rows="15"
                                            ></v-textarea> -->
                                            <div class="text-right mb-1" style="min-height: 18px;">
                                               <div class="editor-header-actions">
                                                <editor-format-info
                                                  v-if="isNotClient"
                                                  :format="storyboardPlaceholders.briefText"
                                                />
                                                <v-menu
                                                  v-show="boxItem.showChatBodyTwo"
                                                  :close-on-content-click="false"
                                                  bottom
                                                  offset-x
                                                >
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-badge
                                                      @click.stop="showBodyChatBoxTwo(deliIndex, boxIdx)"
                                                      :value="boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : ''"
                                                      :content="boxItem.bodyChatTwo ? boxItem.bodyChatTwo.length : ''"
                                                      color="black"
                                                      overlap
                                                      style="margin-left:-10px;"
                                                      v-if="isCommentSection"
                                                    >
                                                      <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        text
                                                        style="padding:0;min-width:34px;"
                                                        @click="showBodyChatBoxTwo(deliIndex, boxIdx)"
                                                        v-if="isCommentSection"
                                                      >
                                                        <v-icon color="secondary">chat</v-icon>
                                                      </v-btn>
                                                    </v-badge>
                                                  </template>
                                                  <v-card max-width="300" style="text-align: left;">
                                                    <v-card-text style="background-color:#fff;padding:0">
                                                      <chatbox
                                                        :messages="boxItem.bodyChatTwo"
                                                        title=""
                                                        @sendMessage="sendBodyCommentTwo(boxItem.id, $event, 'bodyChatTwo')"
                                                      />
                                                    </v-card-text>
                                                  </v-card>
                                                </v-menu>
                                              </div>
                                            </div>
                                            
                                            <sun-editor
                                              v-if="isNotClient"
                                              class="body-info-txt"
                                              v-model="boxItem.briefPointer"
                                              :button-list="storyboardToolbar"
                                              :placeholder="storyboardPlaceholders.briefText"
                                              width="100%"
                                              height="420"
                                            />
                                            <div
                                              class="cp"
                                              style="min-height: 420px;max-height: 420px;overflow-y: auto;margin-top: 5px;"
                                              v-if="isClient"
                                              v-html="renderHTML(boxItem.briefPointer)"
                                            >
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan="2">
                                            <!-- <v-textarea
                                              class="sm-text-area"
                                              height="150px"
                                              placeholder="CTA - Call To Action 
          Scene 8:
          "
                                              v-model="boxItem.callToAction"
                                              v-if="isNotClient"
                                              outlined
                                              required
                                              dense
                                              hide-details
                                            ></v-textarea> -->
                                            <div class="d-flex flex-row align-center justify-space-between mb-1">
                                              <span class="tbl-inner-title">CTA (input your final CTA scene, not caption)</span>
                                              <div class="editor-header-actions">
                                                <editor-format-info
                                                  v-if="isNotClient"
                                                  :format="storyboardPlaceholders.callToAction"
                                                />
                                                <v-menu
                                                  v-show="boxItem.showChatCta"
                                                  :close-on-content-click="false"
                                                  bottom
                                                  offset-x
                                                >
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-badge
                                                      @click.stop="showCtaChatBox(deliIndex, boxIdx)"
                                                      :value="boxItem.ctaComments ? boxItem.ctaComments.length : ''"
                                                      :content="boxItem.ctaComments ? boxItem.ctaComments.length : ''"
                                                      color="black"
                                                      overlap
                                                      style="margin-left:-10px;"
                                                      v-if="isCommentSection"
                                                    >
                                                      <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        text
                                                        style="padding:0;min-width:34px;"
                                                        @click="showCtaChatBox(deliIndex, boxIdx)"
                                                        v-if="isCommentSection"
                                                      >
                                                        <v-icon color="secondary">chat</v-icon>
                                                      </v-btn>
                                                    </v-badge>
                                                  </template>
                                                  <v-card max-width="300" style="text-align: left;">
                                                    <v-card-text style="background-color:#fff;padding:0">
                                                      <chatbox
                                                        :messages="boxItem.ctaComments"
                                                        title=""
                                                        @sendMessage="sendCtaComment(boxItem.id, $event, 'ctaComments')"
                                                      />
                                                    </v-card-text>
                                                  </v-card>
                                                </v-menu>
                                              </div>
                                            </div>
                                            <sun-editor
                                              v-if="isNotClient"
                                              v-model="boxItem.callToAction"
                                              :button-list="storyboardToolbar"
                                              :placeholder="storyboardPlaceholders.callToAction"
                                              width="100%"
                                              height="150"
                                            />
                                            <p
                                              class="cp"
                                              style="min-height:150px;max-height: 150px;overflow-y: auto;"
                                              v-if="isClient"
                                              v-html="renderHTML(boxItem.callToAction)"
                                            >
                                            </p>
                                          </td>
                                          <td class="pa-2">
                                          </td>
                                        </tr>
                                        <!-- <tr>
                                          <td class="pa-2">
                                            <p class="h4 font-weight-bold mb-2">Reference links/images</p>
                                          </td>
                                          <td class="pa-2 pt-5">
                                            <v-radio-group v-model="creatorConceptData.refLinkType" required row>
                                              <v-radio value="upload" label="Image Upload" class="justify-center"></v-radio>
                                              <v-radio value="link" label="Link" class="justify-center"></v-radio>
                                            </v-radio-group>
                                            <div v-if="creatorConceptData.refLinkType === 'upload'">
                                              <custom-file-upload
                                                :refresh="fileUploadRefresh"
                                                :multiple="true"
                                              />
                                            </div>
                                            <v-text-field
                                              v-if="creatorConceptData.refLinkType === 'link'"
                                              dense
                                              class="purple-input"
                                              v-model="creatorConceptData.igReelLink"
                                              type="textbox"
                                              outlined
                                              required
                                              hide-details
                                            />
                                            <v-btn class="secondary mt-2" small dense>
                                              + Add More
                                            </v-btn>
                                          </td>
                                        </tr> -->
                                      </tbody>
                                  </table>
                                </v-flex>
                                <!-- <v-flex
                                class="flex xs1"
                                style="max-width:21px;margin-top:-10px;"
                                v-if="isClient">
                                  <div class="mt-2">
                                    <v-menu                                                            
                                      v-show="boxItem.showChat"
                                      :close-on-content-click="false"
                                      bottom
                                      offset-x
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn 
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="showChatBox(deliIndex, boxIdx)">
                                          <v-icon color="primary">chat</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-card max-width="300" style="text-align: left;">
                                        <v-card-text style="background-color:#fff;padding:0">
                                          <chatbox
                                            :messages="boxItem.comments"
                                            title=""
                                            @sendMessage="sendComment(boxItem.id, $event)"
                                          />
                                        </v-card-text>
                                      </v-card>
                                    </v-menu>
                                  </div>
                                </v-flex> -->
                              </v-col>
                            </div>
                            <div v-if="deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn'">
                              <v-col class="col-xs-12 col-md-12">
                                <div class="d-flex flex-row mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Concept:</span>
                                  <v-textarea
                                    v-model="deliItem.concept"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                                <div class="d-flex flex-row mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Reason for concept:</span>
                                  <v-textarea
                                    v-model="deliItem.reasonConcept"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                                <div class="d-flex flex-row mb-2">
                                  <span class="h4 font-weight-bold mb-2 col-2" style="min-width:160px;">Music choice:</span>
                                  <v-textarea
                                    v-model="deliItem.musicChoice"
                                    :disabled="isClient"
                                    outlined
                                    required
                                    dense
                                    hide-details
                                    rows="5"
                                  ></v-textarea>
                                </div>
                              </v-col>
                              <v-col class="col-xs-12 col-md-12" v-for="(boxItem, boxIdx) in deliItem.boxes" :key="boxIdx">
                                <table class="content-script-table carousel-content-table" style="border:none" dense>
                                    <thead>
                                      <tr>
                                        <th width="5%" class="text-left">
                                          IMAGE
                                        </th>
                                        <th width="40%" class="text-left">
                                          Description of image/gif
                                        </th>
                                        <th width="30%" class="text-left">
                                          Text on image (if any)
                                        </th>
                                        <th width="20%" class="text-left">
                                          Reference image
                                        </th>
                                        <th width="5%" class="text-left">
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(imgRow, imgRowIndex) in boxItem.images" :key="imgRow.id">
                                        <td class="text-center">
                                          {{ imgRowIndex + 1 }}
                                        </td>
                                        <td class="pt-0">
                                          <!-- <v-textarea
                                            class="sm-text-area"
                                            height="150px"
                                            placeholder=""
                                            v-model="imgRow.imgDescription"
                                            v-if="isNotClient"
                                            outlined
                                            dense
                                            hide-details
                                          ></v-textarea> -->
                                          <editor-comments
                                            v-if="isCommentSection"
                                            :messages="imgRow.imgDescriptionComments"
                                            title="Image description"
                                            @sendMessage="sendComment(imgRow.id, $event, 'imgDescriptionComments')"
                                          />
                                          <sun-editor
                                            v-if="isNotClient"
                                            v-model="imgRow.imgDescription"
                                            :button-list="storyboardToolbar"
                                            placeholder=""
                                            width="100%"
                                            height="150"
                                          />
                                          <div
                                            class="cp"
                                            style="min-height: 150px;max-height: 150px;overflow-y: auto;margin-top: 5px;"
                                            v-if="isClient"
                                            v-html="renderHTML(imgRow.imgDescription)"
                                          >
                                          </div>
                                        </td>
                                        <td class="pt-0">
                                          
                                          <!-- <v-textarea
                                            class="sm-text-area"
                                            height="150px"
                                            placeholder=""
                                            v-model="imgRow.textImage"
                                            v-if="isNotClient"
                                            outlined
                                            dense
                                            hide-details
                                          ></v-textarea> -->
                                          <editor-comments
                                            v-if="isCommentSection"
                                            :messages="imgRow.textImageComments"
                                            title="Text on image"
                                            @sendMessage="sendComment(imgRow.id, $event, 'textImageComments')"
                                          />
                                          <sun-editor
                                            v-if="isNotClient"
                                            v-model="imgRow.textImage"
                                            :button-list="storyboardToolbar"
                                            placeholder=""
                                            width="100%"
                                            height="150"
                                          />
                                          <div
                                            class="cp"
                                            style="min-height: 150px;max-height: 150px;overflow-y: auto;margin-top: 5px;"
                                            v-if="isClient"
                                            v-html="renderHTML(imgRow.textImage)"
                                          >
                                        </div>
                                        </td>
                                        <td class="pt-0">
                                          <div class="reference-upload-card carousel-reference-card">
                                            <v-btn-toggle
                                              v-model="imgRow.refLinkType"
                                              class="reference-type-toggle"
                                              v-if="isNotClient"
                                              mandatory
                                              dense>
                                              <v-btn value="upload" small>
                                                <v-icon left small>mdi-image-outline</v-icon>
                                                Image
                                              </v-btn>
                                              <v-btn value="link" small>
                                                <v-icon left small>mdi-link-variant</v-icon>
                                                Link
                                              </v-btn>
                                            </v-btn-toggle>
                                            <v-text-field
                                              v-if="imgRow.refLinkType === 'link'"
                                              dense
                                              class="purple-input reference-link-field"
                                              v-model="imgRow.link"
                                              type="textbox"
                                              outlined
                                              required
                                              hide-details
                                              placeholder="Paste reference link"
                                            />
                                            <div class="reference-upload-dropzone" :class="{'has-file': imgRow.imgName}" v-if="imgRow.refLinkType === 'upload'">
                                              <v-icon class="reference-upload-icon" color="secondary">
                                                {{ imgRow.imgName ? 'mdi-check-circle' : 'mdi-cloud-upload-outline' }}
                                              </v-icon>
                                              <div class="reference-upload-copy">
                                                <a :href="imgRow.imgUrl" target="_blank" v-if="imgRow.imgName">{{ getReferenceFileName(imgRow) }}</a>
                                                <span v-if="!imgRow.imgName">Upload image</span>
                                                <small v-if="isNotClient">Select multiple files to add rows at once</small>
                                              </div>
                                              <direct-file-upload
                                                class="reference-upload-action"
                                                :icon-only="true"
                                                :multiple="true"
                                                @setMedias="uploadFile(deliIndex, boxIdx, imgRowIndex, ...arguments)"
                                                v-if="isNotClient"
                                              />
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <v-btn
                                            v-if="isNotClient"
                                            color="danger"
                                            @click="deleteImage(deliIndex, boxIdx, imgRowIndex)"
                                            text
                                            x-small>
                                            <v-icon color="red">mdi-close-circle</v-icon>
                                          </v-btn>
                                        </td>
                                      </tr>
                                    </tbody>
                                </table>
                                <v-btn class="reference-add-btn" small text v-if="isNotClient" @click="addIgCarousel(deliIndex, boxIdx)">
                                  <v-icon left small>mdi-plus</v-icon>
                                  Add reference
                                </v-btn>
                              </v-col>
                            </div>
                          </div>
                          <!-- End IG Reel -->
                          <!-- Start IG Story -->
                          <!-- <v-col class="col-xs-12 col-md-12" style="background: #dddada;">
                            <div>
                              <span class="h4 font-weight-bold mb-2">IG Story</span>
                            </div>
                          </v-col>
                          <v-col class="col-xs-12 col-md-12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      Descriptions of scenes
                                    </th>
                                    <th class="text-left">
                                      Include text overlays / voiceover script in each scene
                                    </th>
                                    <th class="text-left">
                                      Reference links/images
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class="pa-2">
                                      INTRO: (can be hook/ theme/ title of your video)
                                      <v-textarea
                                        placeholder="What will make your audience not skip your story? "
                                        v-model="creatorConceptData.storyScenesInfo"
                                        outlined
                                        required
                                      ></v-textarea>
                                    </td>
                                    <td class="pa-2">
                                      <v-textarea
                                        class="pt-5"
                                        placeholder="Text: 
    VO: 

    Relate 2-3 pointers of brief into your concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)
    "
                                        v-model="creatorConceptData.storyText"
                                        outlined
                                        required
                                      ></v-textarea>
                                    </td>
                                    <td class="pa-2" rowspan="3">
                                      <div style="margin-top:-295px;">
                                        <div v-for="(item, index) in creatorConceptData.igStoryImages" :key="index">
                                          <div class="d-flex flex-row">
                                            <v-radio-group v-model="item.refLinkType" required row>
                                              <v-radio value="upload" label="Image Upload" class="justify-center"></v-radio>
                                              <v-radio value="link" label="Link" class="justify-center"></v-radio>
                                            </v-radio-group>
                                            <v-btn
                                              style="margin-top:25px;"
                                              color="danger"
                                              @click="deleteIGStory(index)"
                                              text
                                              x-small
                                              v-if="index > 0">
                                              <v-icon color="red">mdi-close-circle</v-icon>
                                            </v-btn>
                                          </div>
                                          <div v-if="item.refLinkType === 'upload'">
                                            <custom-file-upload
                                              :refresh="fileUploadRefresh"
                                              :multiple="true"
                                            />
                                          </div>
                                          <v-text-field
                                            v-if="item.refLinkType === 'link'"
                                            dense
                                            class="purple-input"
                                            v-model="item.link"
                                            type="textbox"
                                            outlined
                                            required
                                            hide-details
                                          />
                                        </div>
                                        <v-btn class="secondary mt-2" @click="addIgStoryImage()"  small dense>
                                          + Add More
                                        </v-btn>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="pa-2">
                                    </td>
                                    <td class="pa-2">
                                      <v-textarea
                                        class="pt-5"
                                        placeholder="Text: VO: Relate 2-3 pointers of brief into your concept (keep it less ad-like, DO NOT COPY USPs from the campaign brief)"
                                        v-model="creatorConceptData.storyScenesInfoTwo"
                                        outlined
                                        required
                                      ></v-textarea>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="pa-2">
                                      <v-textarea
                                        placeholder="CTA - Call To Action 
    Scene 8:
    "
                                        v-model="creatorConceptData.scenesInfo"
                                        outlined
                                        required
                                      ></v-textarea>
                                    </td>
                                    <td class="pa-2">
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col> -->
                          <!-- End IG Story -->

                          <!-- Start IG Carousel -->
                          <!-- <v-col class="col-xs-12 col-md-12" style="background: #dddada;">
                            <div>
                              <span class="h4 font-weight-bold mb-2">IG Carousel</span>
                            </div>
                          </v-col>
                          <v-col class="col-xs-12 col-md-12">
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">
                                      IMAGE
                                    </th>
                                    <th class="text-left">
                                      Description of image/gif
                                    </th>
                                    <th class="text-left">
                                      Text on image (if any)
                                    </th>
                                    <th class="text-left">
                                      Reference image
                                    </th>
                                    <th class="text-left">
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in creatorConceptData.igCarousels" :key="index">
                                    <td>
                                      {{ index + 1 }}
                                    </td>
                                    <td>
                                      <v-textarea
                                        class="pt-5"
                                        placeholder=""
                                        v-model="item.imgDescription"
                                        outlined
                                      ></v-textarea>
                                    </td>
                                    <td>
                                      
                                      <v-textarea
                                        class="pt-5"
                                        placeholder=""
                                        v-model="item.textImage"
                                        outlined
                                      ></v-textarea>
                                    </td>
                                    <td class="pa-2">
                                      <div>
                                        <v-radio-group v-model="item.refLinkType" required row>
                                          <v-radio value="upload" label="Image Upload" class="justify-center"></v-radio>
                                          <v-radio value="link" label="Link" class="justify-center"></v-radio>
                                        </v-radio-group>
                                        <div v-if="item.refLinkType === 'upload'">
                                          <custom-file-upload
                                            :refresh="fileUploadRefresh"
                                            :multiple="true"
                                          />
                                        </div>
                                        <v-text-field
                                          v-if="item.refLinkType === 'link'"
                                          dense
                                          class="purple-input"
                                          v-model="item.link"
                                          type="textbox"
                                          outlined
                                          required
                                          hide-details
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <v-btn
                                        color="danger"
                                        @click="deleteCarousel(index)"
                                        text
                                        x-small>
                                        <v-icon color="red">mdi-close-circle</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                            <v-btn class="secondary mt-2" @click="addIgCarousel" dense>
                              + Add More
                            </v-btn>
                          </v-col> -->
                        </v-col>
                      </v-col>
                    </v-row>
                    <v-row style="margin-right:15px">
                      <v-col cols="12" class="text-right">
                        <v-btn :disabled="submitting" v-if="isNotClient" @click="submitCreatorConcept" class="secondary" x-large>
                          <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                          Submit
                        </v-btn>
                        <v-btn :disabled="submitting" v-if="isClient && !creatorConceptData.approved" @click="approveCreatorConcept" class="success" x-large>
                          <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                          Approve
                        </v-btn>
                      </v-col>
                      <v-col cols="12" class="text-left pl-5" v-if="creatorConceptData.versionNo">
                        {{ creatorConceptData.versionNo }}, {{ formatDate(creatorConceptData.createdAt) }}
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
      <v-dialog
        v-model="imgLoading"      
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text style="padding-top:10px;">
            Uploading...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isLoading"      
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text style="padding-top:10px;">
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <version-no-modal
        @updated="reload"
        @success="saveWithVersion"
        v-model="showVersionDialog"
      />
    </div>
  </v-app>
</template>
<script>
  /* eslint-disable */
  import VersionNoModal from './VersionNoModal'
  import CustomFileUpload from '@/components/scoped/custom/CustomFileUpload';
  import DirectFileUpload from '@/components/scoped/custom/DirectFileUpload';
  import ContentPDFGenerator from '../CreatorConcept/ContentPDFGenerator';
  import campaignPDF from '../../Campaign/campaignPDF';
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import pairingAPIs from '../pairingAPIs'
  import campaignAPIs from '../../Campaign/campaignAPIs';
  import campaignHelper from '../../Campaign/campaignHelper';
  import chatbox from './chatbox';
  import utils from '@/utils'
  import config from '@/config';
  import moment from 'moment';
  import SunEditor from '@/components/editor/sunEditor';
  import EditorFormatInfo from './EditorFormatInfo';
  import EditorComments from './EditorComments';
  import logoDataURL from '@/config/logoDataURL';

  export default {
    name: 'CreatorConceptForm',
    components: {
      CustomFileUpload,
      DirectFileUpload,
      VersionNoModal,
      chatbox,
      SunEditor,
      EditorFormatInfo,
      EditorComments
    },
    mixins: [validationMixin],
    validations: function() {
      let validationRules = {
        creatorConceptData: {
          name: {
            required
          },
          concept: {
            required
          },
          reasonConcept: {
            required
          },
          musicChoice: {
            required
          },
          scenesInfo: {
            required
          },
          storyScenesInfo: {
            required
          },
          storyText: {
            required
          },
          storyScenesInfoTwo: {
            required
          },
          $each: {
            deliverables: {
              concept: {
                required
              }
            }
          }
        }
      };
      // this.deliverables.map(deli => {
      // })
      return validationRules
    },
    props: {
      value: Boolean,
      mode: String,
      editData: Object
    },
    data () {
      return {
        creatorConceptData: {
          pairingID: '',
          campaignName: '',
          creatorHandle: '',
          submissionDate: '',
          concept: '',
          reasonConcept: '',
          musicChoice: '',
          deliverableLists: '',
          deliverables: []
          // deliverables: [
          //   {
          //     type: 'igReel',
          //     title: 'IG Reel',
          //     concept: '',
          //     reasonConcept: '',
          //     musicChoice: '',
          //     boxes: [
          //       {
          //         scenesInfo: '',
          //         briefText: '',
          //         images: [
          //           {
          //             refLinkType: 'upload',
          //             link: ''
          //           }
          //         ]
          //       }
          //     ]
          //   },
          //   {
          //     type: 'igStory',
          //     title: 'IG Story',
          //     concept: '',
          //     reasonConcept: '',
          //     musicChoice: '',
          //     boxes: [
          //       {
          //         scenesInfo: '',
          //         briefText: '',
          //         images: [
          //           {
          //             refLinkType: 'upload',
          //             link: ''
          //           }
          //         ]
          //       }
          //     ]
          //   },
          //   {
          //     type: 'igCarousel',
          //     title: 'IG Carousel',
          //     boxes: [
          //       {
          //         images: [
          //           {
          //             imgDescription: '',
          //             textImage: '',
          //             refLinkType: 'upload',
          //             link: ''
          //           }
          //         ]
          //       }
          //     ]
          //   }
          // ]
        },
        mainData: {
          id: ''
        },
        deliverableLists: '',
        isCreateMode: true,
        valid: true,
        fileUploadRefresh: false,
        submitting: false,
        showVersionDialog: false,
        showVersionHistory: false,
        imgLoading: false,
        isLoading: false,
        commentShow: true,
        editContent: "",
        storyboardToolbar: [
          ['undo', 'redo'],
          ['formatBlock'],
          ['bold', 'italic', 'underline', 'strike'],
          ['list', 'align'],
          ['fontColor', 'hiliteColor'],
          ['removeFormat']
        ],
        storyboardPlaceholders: {
          scenesInfo: 'What will make your audience want to watch this content?\n\nScene 1:',
          briefText: `Text:\nVO:\n\nRelate 2-3 pointers of brief into your concept (keep it less ad-like, \nDO NOT COPY USPs from the campaign brief)`,
          briefTextTwo: `Text:\nVO:\n\nRelate 2-3 pointers of brief into your concept (keep it less ad-like, \nDO NOT COPY USPs from the campaign brief)`,
          bodyInfo: `Showcase how you plan to execute every scene and how you’ll feature the product/service that relates to the campaign brief.\n*Not every scene needs to have the product/ USPs\n\nScene 2:\n\nScene 3:`,
          callToAction: 'CTA - Call To Action\n\nScene 8:'
        },
        logoDataUrl: logoDataURL.logo || '/static/img/kobe_bg_main.png',
      }
    },
    computed: {
      currentUserRole: function() {
        return this.$store.state.user ? Number(this.$store.state.user.role) : null;
      },
      isInternal: function() {
        // return true
        return config.userRoles.CLIENT !== this.currentUserRole;
      },
      isClient: function() {
        // return true
        return config.userRoles.CLIENT === this.currentUserRole;
      },
      isNotClient: function() {
        // return true
        return config.userRoles.CLIENT !== this.currentUserRole;
      },
      isCommentSection: function() {
        // return true
        return this.$store.state.user && config.userRoles.INFLUENCER !== this.currentUserRole
      },
      isInternalView: function() {
        return this.$store.state.user && config.userRoles.INFLUENCER !== this.currentUserRole && config.userRoles.CLIENT !== this.currentUserRole
      }
    },
    mounted() {
      // this.addIgReelImage()
      this.getPairedInfluencer()
    },
    watch: {
      editData: async function(newValue) {
        this.getPairedInfluencer()
      }
    },
    methods: {
      addIgCarousel(deliIndex, boxIdx) {
        this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.push(this.normalizeImageComments({
          imgDescription: '',
          textImage: '',
          refLinkType: 'upload',
          link: ''
        }))
      },
      addImage(deliIndex, boxIdx) {
        this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.push({
          refLinkType: 'upload',
          link: ''
        })
      },
      deleteImage(deliIndex, boxIdx, imgIdx) {
        let splicedImg = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images.splice(imgIdx, 1)
        if (splicedImg.length) {
          if (splicedImg[0].imgName) {
            campaignAPIs.deleteS3Object(splicedImg[0].imgName)
          }
        }
      },
      submitCreatorConcept() {
        // this.$v.$touch()
        // if (this.$v.feedback.$error) {
        //   return false
        // }
        this.submitting = true;
        if (this.isInternalView) {
          this.$swal({
            title: 'Double Check!',
            text: 'Make sure you filled all the required information',
            confirmButtonText: 'Save New',
            cancelButtonText: 'Save',
            type: 'info',
            showCancelButton: true,
            showCloseButton: true,
            cancelButtonColor: 'green'
          }).then(result => {
            if (result.value) {
              this.submitting = false
              this.showVersionDialog = true
              this.creatorConceptData.saveOnly = false
            } else if (result.dismiss === 'cancel') {
              this.creatorConceptData.saveOnly = true
              this.saveCreatorConcept()
            }
            setTimeout(() => {
              // Update submitting status
              this.submitting = false;
            }, 1000)
          });
        } else {
          this.$swal({
            title: 'Double Check!',
            text: 'Make sure you filled all the required information',
            confirmButtonText: 'Confirm',
            type: 'info',
            showCancelButton: true,
            showCloseButton: true
          }).then(result => {
            if (result.value) {
              this.saveCreatorConcept()
            } else {
              setTimeout(() => {
                // Update submitting status
                this.submitting = false;
              }, 1000)
            }
          });
        }
      },
      approveCreatorConcept() {
        this.submitting = true;
        this.$swal({
          title: 'Double Check!',
          text: 'Are you sure you want to approve',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'info',
          showCancelButton: true
        }).then(result => {
          let formData = new FormData();
          formData.append('creatorConceptID', this.creatorConceptData.id);
          pairingAPIs
            .approveConceptForm(formData)
            .then(response => {
              // Dismiss modal by triggering the click event on Close button
              // this.close();
              setTimeout(() => {
                // Update submitting status
                this.submitting = false;
              }, 2000)
              // Show success message
              this.$swal({
                text: 'Succesfully Approved Content Storyboard',
                type: 'success',
                allowOutsideClick: false
              }).then(result => {
                if (result.value) {
                  this.$emit('updatedContentScript')
                  this.sendPdf(this.creatorConceptData.pairingID)
                }
              })
            })
            .catch(error => {
              // Update submitting status
              setTimeout(() => {
                this.submitting = false;
              }, 2000)
              // Request failed.
              console.log('error', error);
              this.$swal({
                text: error,
                type: 'error'
              });
            });
        });
      },
      async sendPdf(id) {
        this.viewContentScriptsData = {}
        this.viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(id)
        if (!this.viewContentScriptsData) {
          this.$swal({
            text: 'No Content Scripts Data.',
            type: 'secondary'
          })
        }
        let doc = ContentPDFGenerator.generatePDF(this.viewContentScriptsData)
        // let vm = this
        // setTimeout(function() {
        //   // let fonts = {
        //   //   NotoSans: {
        //   //     normal: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf',
        //   //     bold: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-700-normal.ttf'
        //   //   }
        //   // };
        //   pdfMake.fonts = {
        //     Arial: {
        //       normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
        //       bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
        //       italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        //     }
        //   }
        //   pdfMake.createPdf(doc).download(`asdfasfsadf.pdf`);
        // }, 1000)
        campaignPDF
        .generatePDF(doc)
        .then(async (pdfData) => {
          let bfsBaseFmt = await campaignPDF.generateBasePDF(doc)
          let formData = new FormData();
          formData.append('pairingID', id)
          formData.append('contentFileBase', bfsBaseFmt)
          formData.append('contentFile', pdfData)
          await pairingAPIs.sendContentFlowEmail(formData)
          return true
        })
        .catch(error => {
          console.log('error in converting PDF', error);
        });
        // Create a table with 2 rows and 3 columns
        //   const titleTxt = new Paragraph({
        //     children: [
        //       // new TextRun('Hello World'),
        //       // new TextRun({
        //       //   text: 'Foo Bar',
        //       //   bold: true
        //       // }),
        //       new TextRun({
        //         text: 'Content Storyboard Flow',
        //         bold: true
        //       })
        //     ]
        //   })
        //   // const table = new Table({
        //   //   rows: [
        //   //     new TableRow({
        //   //       children: [
        //   //         new TableCell({
        //   //           children: [new Paragraph("Header 1")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Header 2")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Header 3")],
        //   //         }),
        //   //       ],
        //   //     }),
        //   //     new TableRow({
        //   //       children: [
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 1, Cell 1")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 1, Cell 2")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 1, Cell 3")],
        //   //         }),
        //   //       ],
        //   //     }),
        //   //     new TableRow({
        //   //       children: [
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 2, Cell 1")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 2, Cell 2")],
        //   //         }),
        //   //         new TableCell({
        //   //           children: [new Paragraph("Row 2, Cell 3")],
        //   //         }),
        //   //       ],
      //   //     }),
      //   //   ],
      //   // });
      //   const doc = new Document({
      //     sections: [
      //       {
      //         properties: {},
      //         children: [
      //           titleTxt
      //         ]
      //       }
      //     ]
      //   });

      //   Packer.toBlob(doc).then((blob) => {
      //     console.log(blob);
      //     saveAs(blob, 'example.docx');
      //     console.log('Document created successfully');
      //   });
      // }
      },
      saveWithVersion(versionNo) {
        this.creatorConceptData.versionNo = versionNo
        this.saveCreatorConcept()
      },
      saveCreatorConcept() {
        let formData = new FormData();
        formData.append('creatorConcept', JSON.stringify(this.creatorConceptData));
        pairingAPIs
          .createConceptForm(formData)
          .then(response => {
            // Dismiss modal by triggering the click event on Close button
            // this.close();
            setTimeout(() => {
              // Update submitting status
              this.submitting = false;
            }, 2000)
            if (this.mode === 'edit') {
              // Show success message
              this.$swal({
                text: 'Succesfully Updated Content Scripts Form',
                type: 'success',
                allowOutsideClick: false
              }).then(result => {
                if (result.value) {
                  this.$emit('updatedContentScript')
                }
              })
            } else {
              // Show success message
              this.$swal({
                text: 'Succesfully Submitted Content Scripts Form',
                type: 'success',
                allowOutsideClick: false
              }).then(result => {
                if (result.value) {
                  this.$router.push({path: '/profile'})
                }
              })
            }
          })
          .catch(error => {
            // Update submitting status
            setTimeout(() => {
              this.submitting = false;
            }, 2000)
            // Request failed.
            console.log('error', error);
            this.$swal({
              text: error,
              type: 'error'
            });
          });
      },
      getReferenceFileName(item) {
        if (!item || !item.imgName) return ''
        return item.imgName.split('/').pop()
      },
      async uploadFile(deliIndex, boxIdx, imgIdx, medias) {
        if (!medias.length) return
        this.imgLoading = true
        try {
          for (let mediaIndex = 0; mediaIndex < medias.length; mediaIndex++) {
            const targetImages = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx].images
            let targetIndex = imgIdx
            if (mediaIndex > 0) {
              targetImages.splice(imgIdx + mediaIndex, 0, this.normalizeImageComments({
                refLinkType: 'upload',
                link: ''
              }))
              targetIndex = imgIdx + mediaIndex
            }
            var formData = new FormData();
            formData.append('rawImage', true);
            formData.append('image', medias[mediaIndex]);
            const response = await campaignAPIs.uploadImage(formData)
            if (response) {
              const url = utils.func.constructImageURL(response.url); // Get url from response
              this.$set(targetImages[targetIndex], 'imgUrl', url)
              this.$set(targetImages[targetIndex], 'imgName', response.url)
            }
          }
          this.imgLoading = false
        } catch (error) {
          this.imgLoading = false
          // Request failed.
          console.log('error', error);
          this.$swal({
            text: error,
            type: 'error'
          });
        }
      },
      async getPairedInfluencer() {
        this.isLoading = true
        try {
          let pairingID = null
          if (this.mode === 'edit') {
            pairingID = this.editData.pairingID
          } else {
            pairingID = this.$route.params.id
          }
          let viewContentScriptsData = await pairingAPIs.getContentScriptByPairingID(pairingID)
          if (viewContentScriptsData) {
          console.log('view script')
          this.creatorConceptData = Object.assign({}, viewContentScriptsData)
          this.creatorConceptData.deliverables = this.creatorConceptData.deliverables.map(this.normalizeDeliverableComments)
          this.contentScriptVersions = await pairingAPIs.getContentScriptVersions(viewContentScriptsData.id)
          let paired = await pairingAPIs.getPairedInfluencerStoryBoardOpen(pairingID)
          for (let conceptVersion of this.contentScriptVersions) {
            if (paired) {
              if (paired.items.deliverables_details) {
                let deliDetails = paired.items.deliverables_details
                conceptVersion.deliverableLists = campaignHelper.getDeliverableDetails(deliDetails)
                for (const [key, value] of Object.entries(deliDetails)) {
                  if (key === 'custom') continue
                  let dataObj = {
                    concept: '',
                    reasonConcept: '',
                    musicChoice: '',
                    boxes: [
                      {
                        scenesInfo: '',
                        briefText: '',
                        images: [
                          {
                            refLinkType: 'upload',
                            link: ''
                          }
                        ]
                      }
                    ]
                  }
                  if (value > 0) {
                    if (key === 'no_of_tiktok_posts') {
                      dataObj.type = 'tiktok';
                      dataObj.title = 'TikTok';
                    } else if (key === 'no_of_fb_posts') {
                      dataObj.type = 'fb';
                      dataObj.title = 'Facebook';
                    } else if (key === 'no_of_xhs_posts') {
                      dataObj.type = 'xhs';
                      dataObj.title = 'Xiaohongshu';
                    } else if (key === 'no_of_posts') {
                      dataObj.type = 'igPost';
                      dataObj.title = 'IG Post';
                    } else if (key === 'no_of_carousels') {
                      dataObj.type = 'igCarousel';
                      dataObj.title = 'IG Carousel';
                    } else if (key === 'no_of_stories') {
                      dataObj.type = 'igStory';
                      dataObj.title = 'IG Story';
                    } else if (key === 'no_of_reels') {
                      dataObj.type = 'igReel';
                      dataObj.title = 'IG Reel';
                    } else if (key === 'no_of_li_posts') {
                      dataObj.type = 'linkedIn';
                      dataObj.title = 'LinkedIn Post';
                    } else if (key === 'youtube') {
                      dataObj.type = 'youtube';
                      dataObj.title = 'Youtube Post';
                    }
                    let totalCount = conceptVersion.deliverables.filter(deli => deli.type === dataObj.type).length
                    if (totalCount < value) {
                      let remainCount = value - totalCount 
                      for (let i = 0; i < remainCount; i++) {
                        let pushObj = Object.assign({}, dataObj)
                        pushObj.id = utils.func.generateUniqueId()
                        if (remainCount > 0) {
                          let title = pushObj.title + ' ' + (totalCount + i + 1)
                          pushObj.title = title
                        }
                        conceptVersion.deliverables.push(pushObj)
                        conceptVersion.deliverables = conceptVersion.deliverables.map(this.normalizeDeliverableComments)
                        conceptVersion.deliverables = JSON.parse(JSON.stringify(conceptVersion.deliverables))
                      }
                    }
                  }
                }
              }
            }
          }
          let matchCreatorConcept = this.contentScriptVersions.find(c => c.isMain)
          if (matchCreatorConcept) {
            this.creatorConceptData = Object.assign({}, matchCreatorConcept)
            this.mainData = Object.assign({}, matchCreatorConcept)
            this.creatorConceptData.deliverables = this.creatorConceptData.deliverables.map(this.normalizeDeliverableComments)
          }
            return;
          }
          let paired = await pairingAPIs.getPairedInfluencerStoryBoardOpen(pairingID)
          if (paired) {
          console.log('view script paired')
          this.creatorConceptData.pairingID = pairingID
          if (paired.items) {
            if (paired.items.id) {
              this.creatorConceptData.submissionDate = paired.items.pairing_details.submission_date
              if (this.creatorConceptData.submissionDate) {
                this.creatorConceptData.submissionDate = utils.func.formatCustomDate(this.creatorConceptData.submissionDate, 'DD/MM/YYYY')
              }
            }
            if (paired.items.influencer_details) {
              this.creatorConceptData.creatorHandle = paired.items.influencer_details.instagramHandle
              this.creatorConceptData.influencerID = paired.items.influencer_details.influencerID || null
            }
            if (paired.items.deliverables_details) {
              let deliDetails = paired.items.deliverables_details
              this.creatorConceptData.deliverableLists = campaignHelper.getDeliverableDetails(deliDetails)
              for (const [key, value] of Object.entries(deliDetails)) {
                if (key === 'custom') continue
                // if (key === 'no_of_carousels') {
                //   if (value > 0) {
                //     this.creatorConceptData.deliverables.push({
                //       type: 'igCarousel',
                //       title: 'IG Carousel',
                //       boxes: [
                //         {
                //           images: [
                //             {
                //               imgDescription: '',
                //               textImage: '',
                //               refLinkType: 'upload',
                //               link: ''
                //             }
                //           ]
                //         }
                //       ]
                //     })
                //   }
                // } else {
                // }
                let dataObj = {
                  // type: 'igStory',
                  // title: 'IG Story',
                  concept: '',
                  reasonConcept: '',
                  musicChoice: '',
                  boxes: [
                    {
                      scenesInfo: '',
                      briefText: '',
                      introComments: [],
                      introCommentsTwo: [],
                      bodyComments: [],
                      bodyChatTwo: [],
                      ctaComments: [],
                      showChat: false,
                      showChatTwo: false,
                      showChatBody: false,
                      showChatBodyTwo: false,
                      showChatCta: false,
                      images: [
                        {
                          refLinkType: 'upload',
                          link: ''
                        }
                      ]
                    }
                  ]
                }
                if (value > 0) {
                  if (key === 'no_of_tiktok_posts') {
                    dataObj.type = 'tiktok';
                    dataObj.title = 'TikTok';
                  } else if (key === 'no_of_fb_posts') {
                    dataObj.type = 'fb';
                    dataObj.title = 'Facebook';
                  } else if (key === 'no_of_xhs_posts') {
                    dataObj.type = 'xhs';
                    dataObj.title = 'Xiaohongshu';
                  } else if (key === 'no_of_posts') {
                    dataObj.type = 'igPost';
                    dataObj.title = 'IG Post';
                  } else if (key === 'no_of_carousels') {
                    dataObj.type = 'igCarousel';
                    dataObj.title = 'IG Carousel';
                  } else if (key === 'no_of_stories') {
                    dataObj.type = 'igStory';
                    dataObj.title = 'IG Story';
                  } else if (key === 'no_of_reels') {
                    dataObj.type = 'igReel';
                    dataObj.title = 'IG Reel';
                  } else if (key === 'no_of_li_posts') {
                    dataObj.type = 'linkedIn';
                    dataObj.title = 'LinkedIn Post';
                  } else if (key === 'youtube') {
                    dataObj.type = 'youtube';
                    dataObj.title = 'Youtube Post';
                  }
                  for (let i = 0; i < value; i++) {
                    let pushObj = Object.assign({}, dataObj)
                    pushObj.id = utils.func.generateUniqueId()
                    if (value > 1) {
                      let title = pushObj.title + ' ' + (i + 1)
                      pushObj.title = title
                    }
                    this.creatorConceptData.deliverables.push(pushObj)
                    this.creatorConceptData.deliverables = this.creatorConceptData.deliverables.map(this.normalizeDeliverableComments)
                    this.creatorConceptData.deliverables = JSON.parse(JSON.stringify(this.creatorConceptData.deliverables))
                  }
                }
              }
            }
            let campaignID = paired.items.campaignID || paired.items.CampaignID
            let campaignName = paired.items.campaignName || paired.items.CampaignName
            
            if (campaignID) {
              this.creatorConceptData.campaignID = campaignID
            }
            if (campaignName) {
              this.creatorConceptData.campaignName = campaignName
            } else if (campaignID) {
              let campaign = await campaignAPIs.getCampaignDetailForFeedback(campaignID)
              this.creatorConceptData.campaignName = campaign.name
            }
          }
          }
        } catch (error) {
          console.error('Unable to load content storyboard', error)
        } finally {
          this.isLoading = false
        }
      },
      normalizeImageComments(image) {
        this.$set(image, 'id', image.id || utils.func.generateUniqueId())
        this.$set(image, 'imgDescriptionComments', image.imgDescriptionComments || [])
        this.$set(image, 'textImageComments', image.textImageComments || [])
        return image
      },
      normalizeDeliverableComments(d) {
        d.showChat = false
        d.showComment = true
        d.comments = d.comments || []
        d.boxes = (d.boxes || []).map(box => {
          box.id = box.id || utils.func.generateUniqueId()
          box.showChat = false
          box.showChatTwo = false
          box.showChatBody = false
          box.showChatBodyTwo = false
          box.showChatCta = false
          box.showComment = true
          box.introComments = box.introComments || []
          box.introCommentsTwo = box.introCommentsTwo || []
          box.bodyComments = box.bodyComments || []
          box.bodyChatTwo = box.bodyChatTwo || []
          box.ctaComments = box.ctaComments || []
          box.images = (box.images || []).map(this.normalizeImageComments)
          return box
        })
        return d
      },
      sendComment: function(id, comment, commentField) {
        var newComment = {
          pairingID: this.creatorConceptData.pairingID,
          deliverableBoxId: id,
          text: comment
        };
        if (commentField) {
          newComment.commentField = commentField
        }
        pairingAPIs
          .createComment(newComment)
          .then(comment => {
            this.creatorConceptData.saveOnly = true
            let formData = new FormData();
            formData.append('creatorConcept', JSON.stringify(this.creatorConceptData));
            pairingAPIs.createConceptForm(formData)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error);
          });
      },
      sendCommentTwo: function(id, comment, commentField) {
        this.sendComment(id, comment, commentField)
      },
      sendBodyComment: function(id, comment, commentField) {
        this.sendComment(id, comment, commentField)
      },
      sendBodyCommentTwo: function(id, comment, commentField) {
        this.sendComment(id, comment, commentField)
      },
      sendCtaComment: function(id, comment, commentField) {
        this.sendComment(id, comment, commentField)
      },
      showChatBox(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showChat', !box.showChat)
          return
        }
        this.creatorConceptData.deliverables[deliIndex].showChat = !this.creatorConceptData.deliverables[deliIndex].showChat
      },
      showChatBoxTwo(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showChatTwo', !box.showChatTwo)
          return
        }
        this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatTwo', !this.creatorConceptData.deliverables[deliIndex].showChatTwo)
      },
      showBodyChatBox(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showChatBody', !box.showChatBody)
          return
        }
        this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatBody', !this.creatorConceptData.deliverables[deliIndex].showChatBody)
      },
      showBodyChatBoxTwo(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showChatBodyTwo', !box.showChatBodyTwo)
          return
        }
        this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatBodyTwo', !this.creatorConceptData.deliverables[deliIndex].showChatBodyTwo)
      },
      showCtaChatBox(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showChatCta', !box.showChatCta)
          return
        }
        this.$set(this.creatorConceptData.deliverables[deliIndex], 'showChatCta', !this.creatorConceptData.deliverables[deliIndex].showChatCta)
      },
      closePutComment(deliIndex, boxIdx) {
        if (boxIdx !== undefined) {
          const box = this.creatorConceptData.deliverables[deliIndex].boxes[boxIdx]
          this.$set(box, 'showComment', !box.showComment)
          return
        }
        this.creatorConceptData.deliverables[deliIndex].showComment = !this.creatorConceptData.deliverables[deliIndex].showComment
      },
      switchVersion(data) {
        this.creatorConceptData = Object.assign({}, data)
        this.creatorConceptData.deliverables = this.creatorConceptData.deliverables.map(this.normalizeDeliverableComments)
      },
      async setMainVersion(conceptId) {
        await pairingAPIs.setMainVer(conceptId)
        this.getPairedInfluencer()
      },
      formatDate(date) {
        return moment(date).format('DD-MM-YYYY, HH:mm');
      },
      renderHTML(text) {
        if (text !== undefined && text !== null) {
          return text.replace(/\n/g, `<p><p>`);
        }
        return ''
      }
    }
  }
</script>

<style lang="scss">
  .v-dialog--fullscreen {
    scroll-behavior: smooth;
  }
  .content-script-table {
    border: 1px solid #e1dddd!important;
  }

  #content-story-form .carousel-content-table {
    width: 100%;
    table-layout: fixed;
  }

  .content-script-table td {
    border: none!important;
    padding: 0!important;
  }

  #content-story-form .reference-upload-action .direct-file-upload-btn {
    height: 30px;
    padding: 0 12px;
    box-shadow: none;
    text-transform: none;
  }

  #rate-card-form .multiple-rate .v-text-field__prefix {
    font-size: 11px;
  }

  #rate-card-form .currency-select .v-input__slot {
    padding: 0;
    padding-left: 5px;
  }
  #rate-card-form .currency-select-multiple {
    min-width: 115px;
    max-width: 115px;
  }
  #rate-card-form .more-platform-label {
    margin-bottom: -15px!important;
  }
  #rate-card-date-picker .v-picker__actions.v-card__actions {
    background: #fff!important;
  }
  #content-story-form .sun-editor {
    position: relative;
    z-index: 0;
    border-color: var(--ims-color-border);
  }

  #content-story-form .sun-editor:focus-within,
  #content-story-form .sun-editor:has(.se-list-layer[style*="display: block"]) {
    z-index: 20;
  }

  #content-story-form .sun-editor .se-toolbar {
    outline: 0;
    padding: 2px;
    background: var(--ims-color-surface);
  }

  #content-story-form .sun-editor .se-btn-module-border {
    margin: 0 2px 0 0;
  }

  #content-story-form .sun-editor button {
    width: 26px;
    height: 26px;
  }

  #content-story-form .sun-editor .se-wrapper-inner {
    font-size: 11px;
  }

  #content-story-form .sun-editor .se-wrapper .se-placeholder {
    white-space: pre-wrap;
    overflow: visible;
    text-overflow: clip;
    overflow-wrap: anywhere;
    word-break: normal;
  }
</style>
<style scoped>
  html {
    overflow-y: hidden!important;
  }

  .storyboard-page-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 20px 12px;
  }

  .version-history-toggle {
    flex: 0 0 auto;
    letter-spacing: 0;
    text-transform: none;
  }

  .storyboard-workspace {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
  }

  .version-history-column {
    flex: 0 0 280px;
    width: 280px;
    position: sticky;
    top: 12px;
  }

  .version-history-card {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 32px);
    background-color: var(--ims-color-surface-raised) !important;
  }

  .version-history-title {
    flex: 0 0 auto;
    padding: 14px 16px;
    font-family: var(--ims-font-heading);
    font-size: 16px;
    font-weight: 700;
  }

  .version-history-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 0 8px;
  }

  .version-history-item--selected {
    background: var(--ims-color-primary-soft);
    border-left: 3px solid var(--ims-color-secondary);
  }

  .version-history-actions {
    flex: 0 0 auto;
    padding: 12px;
    border-top: 1px solid var(--ims-color-border);
  }

  .storyboard-editor-column {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  @media (max-width: 959px) {
    .storyboard-page-toolbar {
      align-items: flex-start;
      padding-right: 12px;
      padding-left: 12px;
    }

    .storyboard-workspace {
      flex-direction: column;
    }

    .version-history-column {
      position: static;
      flex-basis: auto;
      width: 100%;
    }

    .version-history-card {
      max-height: 360px;
    }
  }

  .bg-soft-grey {
    background-color: #f6f6f6;
  }

  .bg--white {
    background-color: #fff;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .form-label {
    min-height: 22px;
  }

  .editor-header-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    min-height: 32px;
  }

  .caption-text {
    color: #f79d18;
  }

  .reference-cell {
    vertical-align: top;
    min-width: 250px;
  }

  .reference-upload-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-left: 10px;
  }

  .reference-upload-card {
    border: 1px solid #e3e6ea;
    background: #fff;
    padding: 10px;
    border-radius: 6px;
  }

  .carousel-reference-card {
    margin-top: 5px;
    width: 100%;
    min-width: 0;
  }

  .reference-upload-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .reference-upload-title {
    color: #222;
    font-size: 12px;
    font-weight: 600;
  }

  .reference-remove-btn {
    margin-right: -4px;
  }

  .reference-type-toggle {
    display: flex;
    width: 100%;
    margin-bottom: 8px;
    border: 1px solid #d7dce2;
    border-radius: 4px;
    overflow: hidden;
  }

  .reference-type-toggle .v-btn {
    flex: 1 1 50%;
    min-width: 0!important;
    height: 28px!important;
    text-transform: none;
    letter-spacing: 0;
    font-size: 12px;
  }

  .reference-upload-dropzone {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 72px;
    padding: 10px;
    border: 1px dashed #c4cbd4;
    border-radius: 6px;
    background: #f8fafc;
  }

  .reference-upload-dropzone.has-file {
    border-style: solid;
    border-color: #a3ff12;
    background: #fbfff5;
  }

  .reference-upload-icon {
    flex: 0 0 auto;
  }

  .reference-upload-copy {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    flex-direction: column;
    line-height: 1.35;
  }

  .reference-upload-copy a,
  .reference-upload-copy span {
    color: #1a1a1a;
    font-size: 12px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }

  .reference-upload-copy small {
    color: #6b7280;
    font-size: 11px;
  }

  .reference-link-field {
    width: 100%;
    min-width: 0;
    margin-top: 0!important;
  }

  .reference-add-btn {
    align-self: flex-start;
    color: var(--v-secondary-base)!important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
  }

  .cp {
    min-height: 150px;
    border: 1px solid #bdbdbd;
    padding: 5px;
    font-size: 12px;
    line-height:18px;
  }

  .putComment {
    position: absolute;
    background-color: black;
    padding: 7px;
    color: white;
    opacity: 60%;
    border-radius: 5px;
    z-index: 1;
    right:0;
    bottom:45px;
  }

  /* .td-error {
    margin-bottom: -20px;
    right: 16px;
  } */

  .td-error, .alert-error {
    display: inline-block;
    font-size: 12px;
    right: 15px;
    padding: 5px;
    margin-bottom: 0px;
    color: #fff!important;
  }

  .alert-error {
    right: 0
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .d-sm-table-cell {
    height: auto!important;
    padding: 0;
    padding-left: 15px;
  }

  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    min-height: 750px;
    background-color: #fff;
    padding: 20px;
  }

  .avatar-logo {
    width: 120px!important;
    min-width: 120px!important;
    height: auto!important;
    transition: all 0.5s ease-out;
    text-align: right;
  }

  .avatar-logo img {
    width: 80px
  }

  .storyboard-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
  }

  .storyboard-meta {
    flex: 1 1 auto;
    min-width: 0;
  }
  
  .form-title {
    margin-top: 0;
    margin-bottom: 24px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
    /* padding: 40px; */
    transition: all 0.5s ease-out;
  }

  .tbl-inner-title {
    font-size: 12px;
    font-weight: 600;
    padding-left: 10px;
  }
  
  .sm-text-area {
    font-size: 12px;
  }

  .label-stats {
    min-width: 173px;
    margin: 0px;
  }

  .edit-rate-card-form .label-stats {
    min-width: 100px;
  }

  .edit-rate-card-form .rate-label-title {
    margin-top:-10px;
    font-weight: bold;
  }

  .event-att-section {
    margin-top: 100px;
  }

  .currency-select {
    width: 86px;
    max-width: 60px;
    font-size: 12px;
  }

  .no-boxshadow {
    box-shadow: none!important;
  }





  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }
  
  @media (max-width: 600px) {
    .content {
      padding: 0;
    }
    .storyboard-header {
      flex-direction: column-reverse;
      gap: 12px;
    }

    .avatar-logo {
      height: auto!important;
      min-width: 100%!important;
      width: 100%!important;
      text-align: right;
    }
    
    .form-title {
      float: none;
      padding: 0;
      font-size: 25px;
      width: 100%;
      text-align: center;
    }

    .float-xs-left {
      float: left;
    }

    .td-error, .alert-error {
      width: 100%;
      right: 0;
    }

    .pt-xs-5 {
      padding-top: 15px
    }

    .mb-xs-0 {
      margin-bottom: 0;
    }
  }

  /* @media (max-width: 400px) {
    .platform-select {
      min-width: 50px!important;
      max-width: 50px!important;
    }
  } */

  @media (min-width: 1000px) and (max-width: 1366px) {
    .content {
      flex-basis: 90%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Form.vue?df4522e8